module.exports = __webpack_public_path__ + "img/18.64630d21.jpg";